import { createContext, ReactNode, useContext, useState } from 'react';
import { useBoolean } from '../hooks';
import { FullScreenLoadingContextType } from './types';

const FullScreenLoadingContext =
  createContext<FullScreenLoadingContextType | null>(null);

export const useFullScreenLoadingContext = () => {
  const context = useContext(FullScreenLoadingContext);
  if (!context) {
    throw new Error(
      'useFullScreenLoadingContext must be used within an FullScreenLoadingProvider'
    );
  }
  return context;
};

interface FullScreenLoadingProviderProps {
  children: ReactNode;
  initialOpen?: boolean;
  initialTitle?: string;
}

export const FullScreenLoadingProvider = ({
  children,
  initialOpen = false,
  initialTitle = 'Loading...',
}: FullScreenLoadingProviderProps) => {
  const state = useBoolean(initialOpen);
  const [title, setTitle] = useState<string>(initialTitle);
  const reset = () => {
    state.onFalse();
    setTitle(initialTitle);
  };

  return (
    <FullScreenLoadingContext.Provider
      value={{ state, title, setTitle, reset }}
    >
      {children}
    </FullScreenLoadingContext.Provider>
  );
};
